// extracted by mini-css-extract-plugin
module.exports = {"downloadLink":"DownloadLink_downloadLink__2GaZX","downloadLinkIcon":"DownloadLink_downloadLinkIcon__1CuJw"};